<template>
	<v-container>
		<h1>Bienvenido(a) {{ nombreUsuario }}</h1>
		<span v-if="valor==0">
			<v-row :justify="`space-between`">
				<v-col v-for="(dia,index) in datos" :key="index" cols="1">
					<TarjetaCitas @fechaDeCita="fechaDeCita" :dia="semana[index]" :datos="dia" />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<CitasDelDia :citas="citas" @cita-seleccionada="recibeDatosDeCita"/>
				</v-col>
			</v-row>
		</span>
		<span v-if="valor!=0">
			<v-row>
				<v-col>
					<NotasDeSesion :datosCita="infoDeCita" @cancela-notas="cancelaNotas"/>
				</v-col>
			</v-row>
		</span>
	</v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi'
import TarjetaCitas from '@/components/TarjetaCitas'
import CitasDelDia from '@/components/CitasDelDia'
import NotasDeSesion from '@/components/NotasDeSesion'
export default {
  name: 'Home',
  components: {
		TarjetaCitas,
		CitasDelDia,
		NotasDeSesion,
	},
	data() {
		return {
			valor: 0,
			pacientes: [],
			respuesta: '',
			datos: {},
			citas: [],
			infoDeCita: {},
			nombreUsuario: '',
			esAdmin: false,
			idUsuario: 0,
			semana: ['V', 'S', 'D', 'L', 'M', 'X', 'J', 'V', 'S', 'D'],
			datosCita: {}
		}
	},
	methods: {
		recuperaCitas(infoParaCita, metodo) {
			console.log("Info para cita", infoParaCita)
			console.log("Método", metodo)
			ServiciosApi.consultaCitas(infoParaCita, metodo)
				.then(response => {
					this.respuesta = response.data
					if(this.respuesta.status === 'ok'){
						console.log("Respuesta", this.respuesta.datos)
						if(metodo === 0) {
							this.datos = this.respuesta.datos
							console.log("Entramos a método = 0")
						} else {
							this.citas = this.respuesta.datos
							console.log("Entramos a método = 1")
							console.log("Datos del Arreglo" , this.citas)
						}
					} else {
						console.log("La respuesta fue: ", this.respuesta.status)
						this.citas = []
					}
				})
				.catch(error => {
					console.log("Error", error.response)
				})
		},
		fechaDeCita(event){
			this.recuperaCitas(event, 1)
		},
		recibeDatosDeCita(event){
			console.log("Dentro de Home, evento: ", event)
			this.valor= event.valor
			this.infoDeCita = event
		},
		cancelaNotas(event){
			this.valor= event
		}
	},
	mounted: function() {
		var idTerapeuta = 0
		var fecha = new Date()
		console.log("Fecha", fecha)
		var fechaFormateada = new Date().toJSON().slice(0,10)
		console.log("Fecha formateada", fechaFormateada)
		if(!this.$session.exists()){
			this.$router.push('/login')
		} else {
			this.nombreUsuario = this.$session.get('nombre')
			this.esAdmin = this.$session.get('esAdmin')
			this.idUsuario = this.$session.get('idUsuario')
			if(!this.esAdmin){
				idTerapeuta = this.idUsuario
			}
			const infoParaCita = {
				idTerapeuta: idTerapeuta,
				fechaActual: fechaFormateada,
			}
			this.recuperaCitas(infoParaCita,0)
		} 
	},

}
</script>
